import React from 'react';
import { useLanguage } from './LanguageContext';
export const BeforeAfter = () => {
  const {
    t
  } = useLanguage();
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-gold-light py-16 md:py-20" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-10 md:mb-12 px-2" data-id="element-16">
          <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[4px] uppercase block mb-4" data-id="element-17">
            {t('ba.label')}
          </span>
          <h2 className="font-montserrat font-extrabold text-[26px] md:text-[42px] text-brand-navy mb-4 leading-[1.3] md:leading-tight" data-id="element-18">
            {t('ba.title')}
          </h2>
          <p className="font-inter text-[15px] md:text-[18px] text-[#4A5568] max-w-[600px] mx-auto" data-id="element-19">
            {t('ba.sub')}
          </p>
        </div>

        <div className="max-w-[800px] mx-auto" data-id="element-20">
          {/* Single Column Layout: Image -> Video -> Image */}
          <div className="flex flex-col gap-10 mb-12" data-id="element-21">
            {/* Card 1: Toilet Bowl */}
            <div className="flex flex-col items-center w-full mx-auto" data-id="element-22">
              <div className="w-full h-auto overflow-hidden rounded-[12px] bg-[#F8F6F2] flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/rPzaKN7zJcbMkNSXQcZhhN/Toilet_bowl.png" alt="Toilet Bowl Deep Clean Before and After" className="w-full h-auto object-contain rounded-[12px]" data-id="element-24" />
              </div>
              <div className="bg-brand-navy text-white font-inter font-medium text-[13px] px-4 py-1.5 rounded-full shadow-sm text-center w-full mt-3" data-id="element-25">
                ✓ Toilet Bowl Deep Clean · Miami, FL
              </div>
            </div>

            {/* Video Section (Moved here) */}
            <div className="w-full mx-auto flex flex-col items-center" data-id="element-26">
              <div className="text-center mb-6" data-id="element-27">
                <span className="text-brand-gold font-montserrat font-medium text-[12px] tracking-[4px] uppercase block mb-3" data-id="element-28">
                  ✦ SEE US IN ACTION ✦
                </span>
                <h3 className="font-playfair font-bold text-[28px] md:text-[36px] text-brand-navy mb-2 leading-[1.2]" data-id="element-29">
                  Watch What We Do Different.
                </h3>
                <p className="font-inter text-[15px] md:text-[16px] text-gray-500" data-id="element-30">
                  Real cleaning. Real results. No shortcuts.
                </p>
              </div>
              <div className="w-full rounded-[16px] overflow-hidden shadow-[0_12px_40px_rgba(27,43,94,0.15)] border-2 border-brand-navy bg-black aspect-video relative" data-id="element-31">
                <video className="w-full h-full object-cover" controls playsInline preload="metadata" poster="https://cdn.magicpatterns.com/uploads/4Yd2RGAxd3E9T2So6Q1v7Y/twogirls-video.mp4#t=0.1" data-id="element-32">
                  <source src="https://cdn.magicpatterns.com/uploads/4Yd2RGAxd3E9T2So6Q1v7Y/twogirls-video.mp4" type="video/mp4" data-id="element-33" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="text-center mt-4" data-id="element-34">
                <p className="font-inter italic text-brand-gold text-[12px] md:text-[13px]" data-id="element-35">
                  ✦ Licensed · Insured · Detail-Oriented · Miami & Broward
                </p>
              </div>
            </div>

            {/* Card 2: Shower Head */}
            <div className="flex flex-col items-center w-full mx-auto" data-id="element-36">
              <div className="w-full h-auto overflow-hidden rounded-[12px] bg-[#F8F6F2] flex items-center justify-center shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-37">
                <img src="https://cdn.magicpatterns.com/uploads/amPmUJXMELKdPn32WRKdXu/Shower_head.jpg" alt="Shower Head Deep Clean Before and After" className="w-full h-auto object-contain rounded-[12px]" data-id="element-38" />
              </div>
              <div className="bg-brand-navy text-white font-inter font-medium text-[13px] px-4 py-1.5 rounded-full shadow-sm text-center w-full mt-3" data-id="element-39">
                ✓ Shower Head Deep Clean · Miami, FL
              </div>
            </div>
          </div>

          {/* Stats Bar — single row on mobile, equal columns */}
          <div className="bg-white py-5 px-3 md:p-7 md:px-10 grid grid-cols-3 md:flex md:flex-row md:justify-between items-center gap-2 md:gap-6 shadow-lg rounded-[20px]" style={{
          borderTop: '3px solid #C9A84C'
        }} data-id="element-40">
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-41">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-42">
                100%
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-43">
                {t('ba.stat1')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-44" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left border-x md:border-0 border-[#F0DCE6]" data-id="element-45">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-gold leading-none" data-id="element-46">
                24h
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-47">
                {t('ba.stat2')}
              </span>
            </div>
            <div className="hidden md:block w-[1px] h-10 bg-[#F0DCE6]" data-id="element-48" />
            <div className="flex flex-col md:flex-row items-center md:items-center gap-1 md:gap-3 text-center md:text-left" data-id="element-49">
              <span className="font-montserrat font-extrabold text-[28px] md:text-[32px] text-brand-navy leading-none" data-id="element-50">
                5★
              </span>
              <span className="font-inter text-[11px] md:text-[13px] text-[#4A5568] md:max-w-[120px] leading-tight" data-id="element-51">
                {t('ba.stat3')}
              </span>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 md:mt-9 px-4 md:px-0" data-id="element-52">
          <button onClick={() => scrollTo('contact')} className="bg-brand-gold hover:bg-white text-brand-navy hover:text-brand-navy font-montserrat font-extrabold w-full sm:w-auto h-[48px] md:h-[56px] px-6 md:px-11 rounded-[28px] inline-flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5 text-[14px] md:text-base" style={{
          boxShadow: '0 8px 25px rgba(201,168,76,0.40)'
        }} data-id="element-53">
            {t('ba.cta')}
          </button>
        </div>
      </div>
    </section>;
};